import React, { useState, useEffect } from "react";
import "./layout.css";
import { Box } from "@mui/material";
import { SidebarData } from "./sidebarData";
import { Link, useLocation } from "react-router-dom";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";

const Sidebar = () => {
  const location = useLocation();
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [activeItem, setActiveItem] = useState("");
  const [activeSubItem, setActiveSubItem] = useState("");

  const handleSubMenuToggle = (id) => {
    setOpenSubMenu((prev) => (prev === id ? null : id));
    if (activeItem !== id) {
      setActiveSubItem(""); // Reset active sub-item if a different main item is clicked
    }
  };

  useEffect(() => {
    const found = SidebarData.find((d) => d.path === location.pathname);
    if (found) {
      setActiveItem(found.id);
      setActiveSubItem(found.sub_menu ? found.sub_menu.find((sub) => sub.path === location.pathname)?.id : "");
      setOpenSubMenu(found.sub_menu ? found.id : null);
    } else {
      const foundSub = SidebarData.flatMap(d => d.sub_menu || []).find(sub => sub.path === location.pathname);
      if (foundSub) {
        setActiveItem("2"); // Assuming "2" is the id for the "Error" main item
        setActiveSubItem(foundSub.id);
        setOpenSubMenu("2"); // Open the Error submenu
      } else {
        setActiveItem("");
        setActiveSubItem("");
        setOpenSubMenu(null);
      }
    }
  }, [location]);

  return (
    <div className="sidebar">
      <div className="logo">
        <img src={logo} alt="logo" width={130} />
      </div>
      <div className="inner">
        {SidebarData.map((d) => (
          <Box
            component={"div"}
            className={activeItem === d.id ? "active" : ""}
            key={d.id}
            padding={"1% 7%"}
          >
            <Link
              to={d.path || "#"}
              className="link"
              onClick={() => {
                if (d.sub_menu) {
                  handleSubMenuToggle(d.id);
                  if (activeItem !== d.id) {
                    setActiveItem(d.id);
                    setActiveSubItem(d.sub_menu[0]?.id || ""); // Default to the first sub-item
                  }
                } else {
                  setActiveItem(d.id);
                  setActiveSubItem(""); // Reset if there's no submenu
                }
              }}
            >
              <div className="icon">{d.icon}</div> {d.title}{" "}
              {/* {d.sub_menu && (
                <div className="dropdown-icon">
                  <img src={arrow} style={{ transform: openSubMenu === d.id ? "rotate(0deg)" : "rotate(270deg)" }} alt="arrow" />
                </div>
              )} */}
            </Link>

            {d.sub_menu && openSubMenu === d.id && (
              <div className="submenu">
                {d.sub_menu.map((subItem) => (
                  <Box
                    key={subItem.id}
                    className={`submenu-item ${activeSubItem === subItem.id ? "active" : ""}`}
                  >
                    <Link
                      to={subItem.path}
                      className="link"
                      onClick={() => {
                        setActiveSubItem(subItem.id);
                        setOpenSubMenu(null); // Close submenu after selecting a sub-item
                      }}
                    >
                      <div className="icon">{subItem.icon}</div> {subItem.title}
                    </Link>
                  </Box>
                ))}
              </div>
            )}
          </Box>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
